import apiClient from './apiClient';
import PseDataStore from '@/data/datastores/PseDataStore';
import { Pse } from './schemas';

class PseDataStoreGraphQL implements PseDataStore {
  client = apiClient();

  async getCaptcha() {
    try {
      const response = await this.client.query({
        query: Pse.getCaptcha
      });
      const { data } = response;
      return data;
    } catch (error) {
      throw new Error(`${error}`);
    }
  }

  async registerInsuranceValidation(
    period: string,
    campus: string,
    ddjjSusaludDoc: boolean,
    ddjjInsuranceValidity: boolean,
    attachedFiles: any,
    isAutomated: boolean
  ) {
    try {
      const response = await this.client.mutate({
        mutation: Pse.RegisterInsuranceValidation,
        variables: {
          period,
          campus,
          ddjjSusaludDoc,
          ddjjInsuranceValidity,
          attachedFiles,
          isAutomated
        }
      });
      const { data } = response;
      return data?.registerInsuranceValidation;
    } catch (error) {
      throw new Error(`${error}`);
    }
  }
}
export default PseDataStoreGraphQL;
